import { ShoppingCartOutlined } from "@material-ui/icons";
import React, { useState } from "react";
import { useDispatch, connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { addCartItem } from "../../service/api/CartService";
import { requestGrade } from "../../service/api/RequestService";
import Spinner from "../Spinner/Spinner";

import "./RequestGradeCartButton.scss";

const RequestGradeCartButton = ({ company, cartItems, loadingIdentifier, setLoadingIdentifier }) => {

    const [isGrade, setIsGrade] = useState(null);
    const [loading, setLoading] = useState(false);
    const [buttonAddDisabled, setButtonAddDisabled] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();


    const renderIsGrade = (company) => {
        if (company.requestId) {
            return redirectToRequestDetail(company);
        } else
            return isGrade != null ? renderGradeStatus(company) : renderGradeQuery(company)
    }

    const redirectToRequestDetail = (company) => {
        const openRequestDetail = requestId => {
            history.push("/request/" + requestId);
        }
        return (
            <button className="button-status">
                <div className="row">
                    <div className="status" type="button" onClick={() => openRequestDetail(company.requestId)}>
                        Ver Grade
                    </div>
                </div>
            </button>

        );
    }

    const renderIsGradeColumn = (company) => {
        const isCompanyInCart = cartItems.filter(i => i.debtor.identification === company.debtor.identification).length > 0;
        return (
            <button className={`button-add-cart ${isCompanyInCart || buttonAddDisabled ?
                'button-disabled-two tooltip1'
                : ''}`}
                    onClick={() => { addItem(company) }} disabled={isCompanyInCart || buttonAddDisabled}>
                <div className="row">
                    <div className="col-7 text-end">
                        Añadir
                    </div>
                    <div className="col-4 ps-0 text-start">
                        <ShoppingCartOutlined className="ShoppingCartOutlined" />
                    </div>
                </div>
                <span className='tooltip1 tooltiptext'>
                    {company.currentExists ? 'Hay otra solicitud vigente' : !loadingIdentifier ? 'Ya tienes este grade en el carrito' : 'Por favor, espera a que finalice la búsqueda'}
                </span>
            </button>
        );
    }


    const renderIsNotGradeColumn = () => {
        return (
            <button className="button-uncheck">
                <div className="row">
                    <div className="col-12">
                        No disponible
                    </div>
                </div>
            </button>
        );
    }

    const handleClickGradeQuery = (company) => {
        setLoading(true);
        setLoadingIdentifier(company.currentExists ? company.currentExists :company.debtor.identification);
        requestGrade(company.debtor.companyId || company.id).then(isGrade => {
            setIsGrade(isGrade);
            setLoading(false);
            setLoadingIdentifier(null);
        })

    }


    const renderGradeQuery = (company) => {
        const isCompanyInCart = cartItems.filter(i => i.debtor.identification === company.debtor.identification).length > 0;
        if (isCompanyInCart) {
            return renderIsGradeColumn(company);
        }
        return (
            <button className={`button-query ${loadingIdentifier || company.currentExists ? 'button-disabled-two tooltip1' : ''}`}
                    onClick={() => handleClickGradeQuery(company)} disabled={loadingIdentifier || company.currentExists}>
                <div className="row">
                    <div className="col-12 text-center consult-grade"> Consultar Grade</div>
                </div>
                <span className='tooltip1 tooltiptext'>
                    {company.currentExists ? 'Hay otra solicitud vigente' : !loadingIdentifier ? 'Ya tienes este grade en el carrito' : 'Por favor, espera a que finalice la búsqueda'}
                </span>
            </button>

        );

    }

    const renderGradeStatus = (company) => {
        return isGrade != null && isGrade === true ? renderIsGradeColumn(company) : renderIsNotGradeColumn()
    }

    const addItem = item => {
        setButtonAddDisabled(true);
        addCartItem(item, dispatch);
    }

    const renderSpinner = () => {
        return <button className="spinner-button">
            <div className="row">
                <div className="col-6 pe-2 spinner-button-text">
                    Buscando
                </div>
                <div className="col-6 text-start">
                    <Spinner />
                </div>
            </div>
        </button>
    }

    return (
        loading && loadingIdentifier === company.debtor.identification ? renderSpinner() : renderIsGrade(company)
    )
}

const mapStateToProps = (state) => {
    return {
        cartItems: state.items
    }
}

export default connect(mapStateToProps)(RequestGradeCartButton)
